import React from 'react'
import {
  TextField,
  InputAdornment,
  Typography,
  InputLabel,
  MenuItem,
  Select,
  Box,
  LinearProgress,
  IconButton,
  FormHelperText,
  Tooltip
} from '@material-ui/core'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import arSA from 'date-fns/locale/ar-SA'
import enUS from 'date-fns/locale/en-US'
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'
import { useStyles } from './Styles'
import { formatRoute } from 'react-router-named-routes'
import 'moment/locale/ar-sa'
import Moment from 'react-moment'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import ArrowDownwardOutlinedIcon from '@material-ui/icons/ArrowDownwardOutlined'
import { NavLink } from 'react-router-dom'
import { NamedRoutes } from '../../../routes'
import invoicesTypes from '../../../configurations/invoices-types'
import msInvoicesTypes from '../../../configurations/ms-invoices-types.json'
import msReceiverTypes from '../../../configurations/ms-receiver-types.json'
import msIssuerTypes from '../../../configurations/ms-issuer-types.json'
import invoicesStatus from '../../../configurations/invoices-status'
import invoicesSPStatus from '../../../configurations/invoices-sp-status'
import InvoicesTypeForm from './InvoicesTypeForm'
import { InvoicesListingConsumer } from '../../../context/InvoicesListingContext'
import InvoicesActionsMenu from '../ActionsMenu'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import { getStatusIcon } from '../../../utils/helpers'
import AddNewDialog from '../../Dialog/AddNewDialog'
import AddNewForm from '../../../FormFields/EntityAddForm'
import { FormLoader } from '../../Loader/FormLoader'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import EventIcon from '@material-ui/icons/Event'
import InvoicesList from './InvoicesList'
import moment from 'moment'
import InvoicesStatusForm from './InvoicesStatusForm'
import { AuthConsumer } from '../../../context/AuthContext'
import { withStyles } from '@material-ui/core/styles'

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#bad7ef',//'#f5f5f9', bad7ef
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 390,
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #dadde9',
    padding: theme.spacing(2, 1.5)

  },
  arrow: {
    color: '#bad7ef'
  }
}))(Tooltip)
const TableWithFilter = ({
  handleListingFilterSubmit, handleInvoiceTypeFilterSubmit, noFilter, noTypeFilter, listingData, listingPage,
  taxpayerData, locale, listingCount, listingRowsPerPage, handleChangeListingPage, handleChangeListingRowsPerPage,
  onlyDeleteOption, handleDeleteAction, noPagination, references, userPermissions, tabEntityName,
  invoiceTypeFilterBackup, hasContinuationToken, continuationTokens, currentIndex, listingFiltersBackup
}) => {
  const classes = useStyles()
  const intl = useIntl()
  const [filterData, setFilterData] = React.useState({})
  const submitFilterRef = React.useRef(null)
  const handleEnterKeyDown = (event) => {
    if (event.key === 'Enter' && !!submitFilterRef?.current) {
      submitFilterRef.current.click()
    }
  }

  React.useEffect(() => {
    if (!!listingFiltersBackup && !!Object.keys(listingFiltersBackup).length) {
      Object.keys(listingFiltersBackup).forEach((filterKey) => {
        setFilterData(prevState => ({
          ...prevState,
          [filterKey]: Array.isArray(listingFiltersBackup[filterKey]) ? listingFiltersBackup[filterKey] : ((listingFiltersBackup[filterKey] || [0, 1].includes(listingFiltersBackup[filterKey])) ? [listingFiltersBackup[filterKey]] : [])
        }))
      })
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listingFiltersBackup])

  const columns = {
    sp: [
      {
        name: 'uuid',
        key_name: 'spUUID',
        label: intl.formatMessage({ id: 'Fields.label.view.uuidAndID' }),
        options: {
          filter: true,
          filterType: 'custom',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            let msUUID = listingData[dataIndex]?.msUUID || listingData[dataIndex]?.MSuuid || null
            return !!listingData[dataIndex]?.uuid &&
              <div className={classes.uuidWrapper}>
                {(listingData[dataIndex]?.issuerId?.toString() === taxpayerData?.trn?.toString()) ?
                  <ArrowUpwardOutlinedIcon color={'primary'} /> : <ArrowDownwardOutlinedIcon color={'secondary'} />}
                <div className={classes.cellDataWrapper}>
                  <NavLink
                    to={formatRoute(!!msUUID ? NamedRoutes.msSingleInvoice : NamedRoutes.singleInvoice,
                      { id: msUUID ?? listingData[dataIndex]?.uuid })}>{listingData[dataIndex]?.uuid}</NavLink>
                  {!!listingData[dataIndex]?.internalId && <span>{listingData[dataIndex]?.internalId}</span>}
                </div>
              </div>
          },
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.UUID' />:
                <span>{v}</span>
              </div>
            )
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <TextField
                fullWidth
                label={intl.formatMessage({ id: 'Fields.label.view.UUID' })}
                id='spUUID'
                name='spUUID'
                value={filterList[index][0] || ''}
                onKeyDown={handleEnterKeyDown}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              />
            )
          }
        }
      },
      {
        name: 'msUUID',
        key_name: 'msUUID',
        label: intl.formatMessage({ id: 'Fields.label.view.msUUID' }),
        options: {
          filter: true,
          filterType: 'custom',
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.msUUID' />:
                <span>{v}</span>
              </div>
            )
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <TextField
                fullWidth
                label={intl.formatMessage({ id: 'Fields.label.view.msUUID' })}
                id='msUUID'
                name='msUUID'
                value={filterList[index][0] || ''}
                onKeyDown={handleEnterKeyDown}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              />
            )
          }
        }
      },
      {
        name: 'internalId',
        key_name: 'internalId',
        label: intl.formatMessage({ id: 'Fields.label.view.InternalId' }),
        options: {
          filter: true,
          filterType: 'custom',
          display: 'false',
          viewColumns: false,
          print: false,
          sort: false,
          download: false,
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.InternalId' />:
                <span>{v}</span>
              </div>
            )
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <TextField
                fullWidth
                label={intl.formatMessage({ id: 'Fields.label.view.InternalId' })}
                id='InternalId'
                name='InternalId'
                value={filterList[index][0] || ''}
                onKeyDown={handleEnterKeyDown}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              />
            )
          }
        }
      },
      {
        name: 'dateTimeIssued',
        key_name: 'dateTimeIssued',
        label: intl.formatMessage({ id: 'Fields.label.view.dateTimeIssued' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            // let value = listingData[dataIndex]?.dateTimeIssued
            let value = !!listingData[dataIndex]?.dateTimeIssued ? moment.utc(listingData[dataIndex]?.dateTimeIssued).valueOf() : null
            return !!value &&
              <div className={classes.cellDataWrapper}>
                <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format="hh:mm A">{value}</Moment></span>
              </div>
          }
        }
      },
      {
        name: 'dateTimeReceived',
        key_name: 'dateTimeReceived',
        label: intl.formatMessage({ id: 'Fields.label.view.dateTimeReceived' }),
        options: {
          filter: false,
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            let value = listingData[dataIndex]?.dateTimeReceived
            return !!value &&
              <div className={classes.cellDataWrapper}>
                <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format="hh:mm A">{value}</Moment></span>
              </div>
          }
        }
      },
      {
        name: 'typeName',
        key_name: 'documentType',
        label: intl.formatMessage({ id: 'Fields.label.view.typeAndVersion' }),
        options: {
          filter: true,
          filterType: 'custom',
          display: !!references ? 'false' : 'true',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            let type = invoicesTypes?.filter(item => item.key.toString().toLowerCase() === listingData[dataIndex]?.typeName?.toString()?.toLowerCase())
            if (!type.length) {
              type = [{
                name_en: listingData[dataIndex]?.documentTypeNamePrimaryLang || '',
                name_ar: listingData[dataIndex]?.documentTypeNameSecondaryLang || ''
              }]
            }
            return !!type && !!type.length &&
              <div className={classes.cellDataWrapper}>
                <strong className={'noWrap'}>{type[0][`name_${locale}`]}</strong>
                <span className={'noWrap'}><FormattedMessage
                  id='Fields.label.view.version' />: {listingData[dataIndex]?.typeVersionName}</span>
              </div>
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <>
                <InputLabel id="DocumentTypeName-label" className={'MuiInputLabel-shrink'}><FormattedMessage
                  id='Fields.label.view.typeName' /></InputLabel>
                <Select
                  fullWidth
                  displayEmpty
                  labelId="DocumentTypeName-label"
                  id="DocumentTypeName"
                  name="DocumentTypeName"
                  MenuProps={{ disableScrollLock: true }}
                  value={filterList[index][0] || ''}
                  label={intl.formatMessage({ id: 'Fields.label.view.typeName' })}
                  onChange={(event) => {
                    if (!!event.target.value) {
                      filterList[index][0] = event.target.value
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                >
                  <MenuItem value={''}><FormattedMessage id='Table.List.Table.All' /></MenuItem>
                  {invoicesTypes?.length && invoicesTypes.map((item) => (
                    !!item.key &&
                    <MenuItem key={item.key} value={item.key}>{item[`name_${locale}`]}</MenuItem>))}
                </Select>
              </>
            )
          },
          customFilterListOptions: {
            render: (v) => {
              let valueArr = v?.length && invoicesTypes?.length ? invoicesTypes.filter((item) => item.key.toString().toLowerCase() === v[0].toString().toLowerCase()) : []
              return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.typeName' />:
                <span>{valueArr[0][`name_${locale}`]}</span>
              </div>
            }
          }
        }
      },
      {
        name: 'total',
        key_name: 'total',
        label: intl.formatMessage({ id: 'Fields.label.view.total' }),
        options: {
          filter: false,
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.totalWrapper}>
              <strong><FormattedNumber value={listingData[dataIndex]?.total || 0} /></strong> <FormattedMessage
                id='EGP' />
            </div>
          }
        }
      },
      {
        name: 'totalSales',
        key_name: 'totalSales',
        label: intl.formatMessage({ id: 'Fields.label.view.totalSales' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.totalWrapper}>
              <strong><FormattedNumber value={listingData[dataIndex]?.totalSales || 0} /></strong> <FormattedMessage
                id='EGP' />
            </div>
          }
        }
      },
      {
        name: 'totalDiscount',
        key_name: 'totalDiscount',
        label: intl.formatMessage({ id: 'Fields.label.view.totalDiscount' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.totalWrapper}>
              <strong><FormattedNumber value={listingData[dataIndex]?.totalDiscount || 0} /></strong> <FormattedMessage
                id='EGP' />
            </div>
          }
        }
      },
      {
        name: 'netAmount',
        key_name: 'netAmount',
        label: intl.formatMessage({ id: 'Fields.label.view.netAmount' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.totalWrapper}>
              <strong><FormattedNumber value={listingData[dataIndex]?.netAmount || 0} /></strong> <FormattedMessage
                id='EGP' />
            </div>
          }
        }
      },
      {
        name: 'issuerName',
        key_name: 'issuerName',
        label: intl.formatMessage({ id: 'Fields.label.view.issuerName' }),
        options: {
          display: !!references ? 'false' : 'true',
          filter: false,
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return (!!listingData[dataIndex]?.issuerName || !!listingData[dataIndex]?.issuerId) &&
              <div className={classes.cellDataWrapper}>
                <strong>{listingData[dataIndex]?.issuerName || ''}</strong>
                {!!listingData[dataIndex]?.issuerId && <span>{listingData[dataIndex]?.issuerId}</span>}
              </div>
          }
        }
      },
      {
        name: 'receiverName',
        key_name: 'receiverName',
        label: intl.formatMessage({ id: 'Fields.label.view.receiverName' }),
        options: {
          filter: false,
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return (!!listingData[dataIndex]?.receiverName || !!listingData[dataIndex]?.receiverId) &&
              <div className={classes.cellDataWrapper}>
                <strong>{listingData[dataIndex]?.receiverName || ''}</strong>
                {!!listingData[dataIndex]?.receiverId && <span>{listingData[dataIndex]?.receiverId}</span>}
              </div>
          }
        }
      },
      {
        name: 'lateSubmissionRequest',
        key_name: 'lateSubmissionRequest',
        label: intl.formatMessage({ id: 'Fields.label.view.lateSubmissionRequest' }),
        options: {
          filter: false,
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.cellDataWrapper}>
              {!!listingData[dataIndex]?.lateSubmissionRequest?.id ?
                <CheckIcon />
                :
                <CloseIcon />
              }
            </div>
          }
        }
      },
      {
        name: 'submissionUUID',
        key_name: 'submissionUUID',
        label: intl.formatMessage({ id: 'Fields.label.view.submissionUUIDAndMS' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.cellDataWrapper}>
              {!!listingData[dataIndex]?.submissionUUID &&
                <strong><NavLink
                  to={formatRoute(NamedRoutes.submission, { id: listingData[dataIndex]?.submissionUUID })}>{listingData[dataIndex]?.submissionUUID}</NavLink></strong>}
              {!!listingData[dataIndex]?.submissionMSUUID && <span>{listingData[dataIndex]?.submissionMSUUID}</span>}
            </div>
          }
        }
      },
      {
        name: 'dateFrom',
        key_name: 'dateFrom',
        label: intl.formatMessage({ id: 'Fields.label.view.dateFrom' }),
        options: {
          display: 'false',
          viewColumns: false,
          filter: true,
          filterType: 'custom',
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.dateFrom' />:
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
              </div>
            )
          },
          filterOptions: {
            names: [],
            display: (filterList, onChange, index, column) => (
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
                <DatePicker
                  autoOk
                  // ToolbarComponent={CustomToolbar}
                  fullWidth
                  format="dd-MM-yyyy"
                  margin="dense"
                  id="dateFrom"
                  name="dateFrom"
                  clearable
                  disableFuture
                  label={intl.formatMessage({ id: 'Fields.label.view.dateFrom' })}
                  placeholder={intl.formatMessage({ id: 'Fields.label.view.dateFrom' })}
                  InputProps={{
                    onKeyDown: handleEnterKeyDown,
                    endAdornment:
                      <InputAdornment position="end">
                        <EventIcon />
                      </InputAdornment>
                  }}
                  value={filterList[index][0] || null}
                  animateYearScrolling
                  onChange={(date) => {
                    if (!!date) {
                      filterList[index][0] = date
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                  cancelLabel={intl.formatMessage({ id: 'datePicker.Cancel' })}
                  okLabel={intl.formatMessage({ id: 'datePicker.confirm' })}
                  clearLabel={intl.formatMessage({ id: 'datePicker.clear' })}
                />
              </MuiPickersUtilsProvider>

            )
          }
        }
      },
      {
        name: 'dateTo',
        key_name: 'dateTo',
        label: intl.formatMessage({ id: 'Fields.label.view.dateTo' }),
        options: {
          display: 'false',
          viewColumns: false,
          filter: true,
          filterType: 'custom',
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.dateTo' />:
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
              </div>
            )
          },
          filterOptions: {
            names: [],
            display: (filterList, onChange, index, column) => (
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
                <DatePicker
                  autoOk
                  // ToolbarComponent={CustomToolbar}
                  fullWidth
                  format="dd-MM-yyyy"
                  margin="dense"
                  id="dateTo"
                  name="dateTo"
                  clearable
                  disableFuture
                  disabled={!filterList[index - 1][0]}
                  minDate={filterList[index - 1][0] || null}
                  minDateMessage={<FormattedMessage id='validationSchema.msInvoices.min.issueTo' />}
                  label={intl.formatMessage({ id: 'Fields.label.view.dateTo' })}
                  placeholder={intl.formatMessage({ id: 'Fields.label.view.dateTo' })}
                  InputProps={{
                    onKeyDown: handleEnterKeyDown,
                    endAdornment:
                      <InputAdornment position="end">
                        <EventIcon />
                      </InputAdornment>
                  }}
                  value={filterList[index][0] || null}
                  animateYearScrolling
                  onChange={(date) => {
                    if (!!date) {
                      filterList[index][0] = date
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                  cancelLabel={intl.formatMessage({ id: 'datePicker.Cancel' })}
                  okLabel={intl.formatMessage({ id: 'datePicker.confirm' })}
                  clearLabel={intl.formatMessage({ id: 'datePicker.clear' })}
                />
              </MuiPickersUtilsProvider>

            )
          }
        }
      },
      {
        name: 'submissionDateFrom',
        key_name: 'submissionDateFrom',
        label: intl.formatMessage({ id: 'Fields.label.view.submissionDateFrom' }),
        options: {
          display: 'false',
          viewColumns: false,
          filter: true,
          filterType: 'custom',
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.submissionDateFrom' />:
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
              </div>
            )
          },
          filterOptions: {
            names: [],
            display: (filterList, onChange, index, column) => (
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
                <DatePicker
                  autoOk
                  // ToolbarComponent={CustomToolbar}
                  fullWidth
                  format="dd-MM-yyyy"
                  margin="dense"
                  id="submissionDateFrom"
                  name="submissionDateFrom"
                  clearable
                  disableFuture
                  label={intl.formatMessage({ id: 'Fields.label.view.submissionDateFrom' })}
                  placeholder={intl.formatMessage({ id: 'Fields.label.view.submissionDateFrom' })}
                  InputProps={{
                    onKeyDown: handleEnterKeyDown,
                    endAdornment:
                      <InputAdornment position="end">
                        <EventIcon />
                      </InputAdornment>
                  }}
                  value={filterList[index][0] || null}
                  animateYearScrolling
                  onChange={(date) => {
                    if (!!date) {
                      filterList[index][0] = date
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                  cancelLabel={intl.formatMessage({ id: 'datePicker.Cancel' })}
                  okLabel={intl.formatMessage({ id: 'datePicker.confirm' })}
                  clearLabel={intl.formatMessage({ id: 'datePicker.clear' })}
                />
              </MuiPickersUtilsProvider>

            )
          }
        }
      },
      {
        name: 'submissionDateTo',
        key_name: 'submissionDateTo',
        label: intl.formatMessage({ id: 'Fields.label.view.submissionDateTo' }),
        options: {
          display: 'false',
          viewColumns: false,
          filter: true,
          filterType: 'custom',
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.submissionDateTo' />:
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
              </div>
            )
          },
          filterOptions: {
            names: [],
            display: (filterList, onChange, index, column) => (
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
                <DatePicker
                  autoOk
                  // ToolbarComponent={CustomToolbar}
                  fullWidth
                  format="dd-MM-yyyy"
                  margin="dense"
                  id="submissionDateTo"
                  name="submissionDateTo"
                  clearable
                  disableFuture
                  disabled={!filterList[index - 1][0]}
                  minDate={filterList[index - 1][0] || null}
                  minDateMessage={<FormattedMessage id='validationSchema.msInvoices.min.submissionTo' />}
                  label={intl.formatMessage({ id: 'Fields.label.view.submissionDateTo' })}
                  placeholder={intl.formatMessage({ id: 'Fields.label.view.submissionDateTo' })}
                  InputProps={{
                    onKeyDown: handleEnterKeyDown,
                    endAdornment:
                      <InputAdornment position="end">
                        <EventIcon />
                      </InputAdornment>
                  }}
                  value={filterList[index][0] || null}
                  animateYearScrolling
                  onChange={(date) => {
                    if (!!date) {
                      filterList[index][0] = date
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                  cancelLabel={intl.formatMessage({ id: 'datePicker.Cancel' })}
                  okLabel={intl.formatMessage({ id: 'datePicker.confirm' })}
                  clearLabel={intl.formatMessage({ id: 'datePicker.clear' })}
                />
              </MuiPickersUtilsProvider>

            )
          }
        }
      },
      {
        name: 'status',
        key_name: 'spStatus',
        label: intl.formatMessage({ id: 'Fields.label.view.StatusAndMs' }),
        options: {
          filter: true,
          filterList: filterData?.spStatus || [],
          filterType: 'custom',
          // display: 'false',
          // viewColumns: false,
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            let status = invoicesStatus?.filter(item => item.key.toString().toLowerCase() === listingData[dataIndex]?.MSStatus?.toString()?.toLowerCase())
            let spStatus = invoicesSPStatus?.filter(item => item.key.toString().toLowerCase() === listingData[dataIndex]?.status?.toString()?.toLowerCase())
            let transformedState = (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.cancelRequestDate && !!listingData[dataIndex]?.cancelRequestDelayedDate)
              ? invoicesStatus?.filter(item => item.key.toString().toLowerCase() === 'cancelled')
              : (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.rejectRequestDate && !!listingData[dataIndex]?.rejectRequestDelayedDate)
                ? invoicesStatus?.filter(item => item.key.toString().toLowerCase() === 'rejected') : null
            let delayedDate = (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.cancelRequestDelayedDate)
              ? listingData[dataIndex]?.cancelRequestDelayedDate
              : (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.rejectRequestDelayedDate)
                ? listingData[dataIndex]?.rejectRequestDelayedDate : null
            return <>
              {!!status && !!status.length && <>
                <div className={classes.statusContainer}>
                  <div
                    className={classes.statusWrapper + ` ${listingData[dataIndex]?.MSStatus?.toString()?.toLowerCase()}`}>
                    {getStatusIcon(status[0]['key'])}
                    <strong>{status[0][`name_${locale}`]}</strong>
                  </div>
                  {!!transformedState && !!transformedState.length && <>
                    <ArrowForwardIcon />
                    <div
                      className={classes.statusWrapper + ` ${transformedState[0]['key']?.toString()?.toLowerCase()}`}>
                      {getStatusIcon(transformedState[0]['key'])}
                      <strong>{transformedState[0][`name_${locale}`]}</strong>
                    </div>
                  </>
                  }
                </div>
                {!!delayedDate &&
                  <div className={classes.statusDelayed}>
                    <label><FormattedMessage id='invoices.action.delayedDate' /></label>
                    <span>( <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                      format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{delayedDate}</Moment></strong>
                      <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                        format="hh:mm A">{delayedDate}</Moment></span> )
                    </span>
                  </div>
                }
              </>}
              {!!spStatus && !!spStatus?.length && <div
                className={classes.statusWrapper + ` spStatus`}>
                {spStatus[0][`name_${locale}`]}
              </div>}
            </>
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <>
                <InputLabel id="Status-label" className={'MuiInputLabel-shrink'}><FormattedMessage
                  id='Fields.label.view.Status' /></InputLabel>
                <Select
                  fullWidth
                  displayEmpty
                  labelId="Status-label"
                  id="Status"
                  name="Status"
                  MenuProps={{ disableScrollLock: true }}
                  value={filterList[index][0] || ''}
                  label={intl.formatMessage({ id: 'Fields.label.view.Status' })}
                  onChange={(event) => {
                    if (!!event.target.value) {
                      filterList[index][0] = event.target.value
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                >
                  <MenuItem value={''}><FormattedMessage id='Table.List.Table.All' /></MenuItem>
                  {invoicesSPStatus?.length && invoicesSPStatus.map((item) => (
                    !!item.key &&
                    <MenuItem key={item.key} value={item.key}>
                      <div className={classes.statusWrapper}>
                        {/*{getStatusIcon(item['key'])}*/}
                        <span>{item[`name_${locale}`]}</span>
                      </div>
                    </MenuItem>))}
                </Select>
              </>
            )
          },
          customFilterListOptions: {
            render: (v) => {
              let valueArr = v?.length && invoicesSPStatus?.length ? invoicesSPStatus.filter((item) => item.key.toString().toLowerCase() === v[0].toString().toLowerCase()) : []
              return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.Status' />:
                <div className={classes.statusWrapper + ` spStatus`}>
                  {/*{getStatusIcon(valueArr[0]['key'])}*/}
                  <span>{valueArr[0][`name_${locale}`]}</span>
                </div>
              </div>
            }
          }
        }
      },
      // {
      //   name: 'MSStatus',
      //   key_name: 'msStatus',
      //   label: intl.formatMessage({ id: 'Fields.label.view.StatusAndMs' }),
      //   options: {
      //     filter: true,
      //     filterType: 'custom',
      //     print: false,
      //     sort: false,
      //     download: false,
      //     customBodyRenderLite: (dataIndex) => {
      //       let status = invoicesStatus?.filter(item => item.key.toString().toLowerCase() === listingData[dataIndex]?.MSStatus?.toString()?.toLowerCase())
      //       let spStatus = invoicesSPStatus?.filter(item => item.key.toString().toLowerCase() === listingData[dataIndex]?.status?.toString()?.toLowerCase())
      //       let transformedState = (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.cancelRequestDate && !!listingData[dataIndex]?.cancelRequestDelayedDate)
      //         ? invoicesStatus?.filter(item => item.key.toString().toLowerCase() === 'cancelled')
      //         : (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.rejectRequestDate && !!listingData[dataIndex]?.rejectRequestDelayedDate)
      //           ? invoicesStatus?.filter(item => item.key.toString().toLowerCase() === 'rejected') : null
      //       let delayedDate = (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.cancelRequestDelayedDate)
      //         ? listingData[dataIndex]?.cancelRequestDelayedDate
      //         : (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.rejectRequestDelayedDate)
      //           ? listingData[dataIndex]?.rejectRequestDelayedDate : null
      //       return <>
      //         {!!status && !!status.length && <>
      //           <div className={classes.statusContainer}>
      //             <div
      //               className={classes.statusWrapper + ` ${listingData[dataIndex]?.MSStatus?.toString()?.toLowerCase()}`}>
      //               {getStatusIcon(status[0]['key'])}
      //               <strong>{status[0][`name_${locale}`]}</strong>
      //             </div>
      //             {!!transformedState && !!transformedState.length && <>
      //               <ArrowForwardIcon/>
      //               <div
      //                 className={classes.statusWrapper + ` ${transformedState[0]['key']?.toString()?.toLowerCase()}`}>
      //                 {getStatusIcon(transformedState[0]['key'])}
      //                 <strong>{transformedState[0][`name_${locale}`]}</strong>
      //               </div>
      //             </>
      //             }
      //           </div>
      //           {!!delayedDate &&
      //           <div className={classes.statusDelayed}>
      //             <label><FormattedMessage id='invoices.action.delayedDate'/></label>
      //             <span>( <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
      //                                     format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{delayedDate}</Moment></strong>
      //                 <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
      //                               format="hh:mm A">{delayedDate}</Moment></span> )
      //               </span>
      //           </div>
      //           }
      //         </>}
      //         {!!spStatus && !!spStatus?.length && <div
      //           className={classes.statusWrapper + ` spStatus`}>
      //           {spStatus[0][`name_${locale}`]}
      //         </div>}
      //       </>
      //     },
      //     filterOptions: {
      //       display: (filterList, onChange, index, column) => (
      //         <>
      //           <InputLabel id="MSStatus-label" className={'MuiInputLabel-shrink'}><FormattedMessage
      //             id='Fields.label.view.MSStatus'/></InputLabel>
      //           <Select
      //             fullWidth
      //             displayEmpty
      //             labelId="MSStatus-label"
      //             id="MSStatus"
      //             name="MSStatus"
      //             MenuProps={{ disableScrollLock: true }}
      //             value={filterList[index][0] || ''}
      //             label={intl.formatMessage({ id: 'Fields.label.view.MSStatus' })}
      //             onChange={(event) => {
      //               if (!!event.target.value) {
      //                 filterList[index][0] = event.target.value
      //               } else {
      //                 filterList[index] = []
      //               }
      //               onChange(filterList[index], index, column)
      //             }}
      //           >
      //             <MenuItem value={''}><FormattedMessage id='Table.List.Table.All'/></MenuItem>
      //             {invoicesStatus?.length && invoicesStatus.map((item) => (
      //               !!item.key &&
      //               <MenuItem key={item.key} value={item.key}>
      //                 <div className={classes.statusWrapper + ` ${item['key']?.toString().toLowerCase()}`}>
      //                   {getStatusIcon(item['key'])}
      //                   <span>{item[`name_${locale}`]}</span>
      //                 </div>
      //               </MenuItem>))}
      //           </Select>
      //         </>
      //       )
      //     },
      //     customFilterListOptions: {
      //       render: (v) => {
      //         let valueArr = v?.length && invoicesStatus?.length ? invoicesStatus.filter((item) => item.key.toString().toLowerCase() === v[0].toString().toLowerCase()) : []
      //         return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
      //           <FormattedMessage id='Fields.label.view.MSStatus'/>:
      //           <div className={classes.statusWrapper + ` ${valueArr[0]['key']?.toString().toLowerCase()}`}>
      //             {getStatusIcon(valueArr[0]['key'])}
      //             <span>{valueArr[0][`name_${locale}`]}</span>
      //           </div>
      //         </div>
      //       }
      //     }
      //   }
      // },
      {
        name: '',
        options: {
          filter: false,
          print: false,
          sort: false,
          viewColumns: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return !!onlyDeleteOption ?
              <IconButton color="secondary" aria-label="Edit" onClick={(e) => {
                !!e?.preventDefault && e.preventDefault()
                !!e?.stopPropagation && e.stopPropagation()
                handleDeleteAction('delete', listingData[dataIndex], listingData[dataIndex]?.uuid)
              }}>
                <DeleteForeverIcon />
              </IconButton>
              :
              <InvoicesActionsMenu selectedRow={listingData[dataIndex]}
                id={listingData[dataIndex]?.uuid}
                msId={listingData[dataIndex]?.msUUID}
                userPermissions={userPermissions}
                isSubmitted={listingData[dataIndex]?.issuerId?.toString() === taxpayerData?.trn?.toString()}
                locale={locale}
                isMs={false}
              />
          }
        }
      }
    ],
    eInvoice: [
      {
        name: 'uuid',
        key_name: 'UUID',
        label: intl.formatMessage({ id: 'Fields.label.view.eInvoiceuuidAndID' }),
        options: {
          filter: true,
          filterType: 'custom',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return !!listingData[dataIndex]?.uuid &&
              <div className={classes.uuidWrapper}>
                {([listingData[dataIndex]?.issuerId?.toString(), listingData[dataIndex]?.issuer?.id?.toString()].includes(taxpayerData?.trn?.toString())) ?
                  <ArrowUpwardOutlinedIcon color={'primary'} /> : <ArrowDownwardOutlinedIcon color={'secondary'} />}
                <div className={classes.cellDataWrapper}>
                  <NavLink
                    to={formatRoute(NamedRoutes.msSingleInvoice, { id: listingData[dataIndex]?.uuid })}>{listingData[dataIndex]?.uuid}</NavLink>
                  {!!listingData[dataIndex]?.internalId ? <span>{listingData[dataIndex]?.internalId}</span> :
                    (!!listingData[dataIndex]?.internalID && <span>{listingData[dataIndex]?.internalID}</span>)}
                </div>
              </div>
          },
          // customFilterListOptions: {
          //   render: (v) => (
          //     <div className={classes.FilterChip}>
          //       <FormattedMessage id='Fields.label.view.eInvoiceUUID' />:
          //       <span>{v}</span>
          //     </div>
          //   )
          // },
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.eInvoiceUUID' />:
                <span>{v}</span>
              </div>
            )
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <TextField
                fullWidth
                label={intl.formatMessage({ id: 'Fields.label.view.eInvoiceUUID' })}
                id='UUID'
                name='UUID'
                value={filterList[index][0] || ''}
                onKeyDown={handleEnterKeyDown}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              />
            )
          }

        }
      },
      {
        name: 'internalId',
        key_name: 'InternalID',
        label: intl.formatMessage({ id: 'Fields.label.view.InternalId' }),
        options: {
          filter: true,
          filterType: 'custom',
          display: 'false',
          viewColumns: false,
          print: false,
          sort: false,
          download: false,
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.InternalId' />:
                <span>{v}</span>
              </div>
            )
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <TextField
                fullWidth
                label={intl.formatMessage({ id: 'Fields.label.view.InternalId' })}
                id='InternalID'
                name='InternalID'
                value={filterList[index][0] || ''}
                onKeyDown={handleEnterKeyDown}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              />
            )
          }
        }
      },
      {
        name: 'dateTimeIssued',
        key_name: 'dateTimeIssued',
        label: intl.formatMessage({ id: 'Fields.label.view.dateTimeIssued' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            let value = listingData[dataIndex]?.dateTimeIssued
            return !!value &&
              <div className={classes.cellDataWrapper}>
                <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format="hh:mm A">{value}</Moment></span>
              </div>
          }
        }
      },
      {
        name: 'dateTimeReceived',
        key_name: 'dateTimeReceived',
        label: intl.formatMessage({ id: 'Fields.label.view.dateTimeReceived' }),
        options: {
          filter: false,
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            let value = listingData[dataIndex]?.dateTimeReceived || listingData[dataIndex]?.dateTimeRecevied
            return !!value &&
              <div className={classes.cellDataWrapper}>
                <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format="hh:mm A">{value}</Moment></span>
              </div>
          }
        }
      },
      {
        name: 'typeName',
        key_name: 'documentType',
        label: intl.formatMessage({ id: 'Fields.label.view.typeAndVersion' }),
        options: {
          filter: true,
          filterType: 'custom',
          display: !!references ? 'false' : 'true',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            let type = invoicesTypes?.filter(item => [listingData[dataIndex]?.typeName?.toString()?.toLowerCase(), listingData[dataIndex]?.documentType?.toString()?.toLowerCase()].includes(item.key.toString().toLowerCase()))
            if (!type.length) {
              type = [{
                name_en: listingData[dataIndex]?.documentTypeNamePrimaryLang || '',
                name_ar: listingData[dataIndex]?.documentTypeNameSecondaryLang || ''
              }]
            }
            return !!type && !!type.length &&
              <div className={classes.cellDataWrapper}>
                <strong className={'noWrap'}>{type[0][`name_${locale}`]}</strong>
                <span className={'noWrap'}><FormattedMessage
                  id='Fields.label.view.version' />: {listingData[dataIndex]?.typeVersionName || listingData[dataIndex]?.documentTypeVersion}</span>
              </div>
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <>
                <InputLabel id="DocumentTypeName-label" className={'MuiInputLabel-shrink'}><FormattedMessage
                  id='Fields.label.view.typeName' /></InputLabel>
                <Select
                  fullWidth
                  displayEmpty
                  labelId="DocumentTypeName-label"
                  id="DocumentTypeName"
                  name="DocumentTypeName"
                  MenuProps={{ disableScrollLock: true }}
                  value={filterList[index][0] || ''}
                  label={intl.formatMessage({ id: 'Fields.label.view.typeName' })}
                  onChange={(event) => {
                    if (!!event.target.value) {
                      filterList[index][0] = event.target.value
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                >
                  <MenuItem value={''}><FormattedMessage id='Table.List.Table.All' /></MenuItem>
                  {msInvoicesTypes?.length && msInvoicesTypes.map((item) => (
                    !!item.key &&
                    <MenuItem key={item.key} value={item.key}>{item[`name_${locale}`]}</MenuItem>))}
                </Select>
              </>
            )
          },
          customFilterListOptions: {
            render: (v) => {
              let valueArr = v?.length && msInvoicesTypes?.length ? msInvoicesTypes.filter((item) => item.key.toString().toLowerCase() === v[0].toString().toLowerCase()) : []
              return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.typeName' />:
                <span>{valueArr[0][`name_${locale}`]}</span>
              </div>
            }
          }
        }
      },
      {
        name: 'total',
        key_name: 'total',
        label: intl.formatMessage({ id: 'Fields.label.view.total' }),
        options: {
          filter: false,
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.totalWrapper}>
              <strong><FormattedNumber value={listingData[dataIndex]?.total || listingData[dataIndex]?.totalAmount || 0} /></strong> <FormattedMessage
                id='EGP' />
            </div>
          }
        }
      },
      {
        name: 'totalSales',
        key_name: 'totalSales',
        label: intl.formatMessage({ id: 'Fields.label.view.totalSales' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.totalWrapper}>
              <strong><FormattedNumber value={listingData[dataIndex]?.totalSales || 0} /></strong> <FormattedMessage
                id='EGP' />
            </div>
          }
        }
      },
      {
        name: 'totalDiscount',
        key_name: 'totalDiscount',
        label: intl.formatMessage({ id: 'Fields.label.view.totalDiscount' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.totalWrapper}>
              <strong><FormattedNumber value={listingData[dataIndex]?.totalDiscount || 0} /></strong> <FormattedMessage
                id='EGP' />
            </div>
          }
        }
      },
      {
        name: 'netAmount',
        key_name: 'netAmount',
        label: intl.formatMessage({ id: 'Fields.label.view.netAmount' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.totalWrapper}>
              <strong><FormattedNumber value={listingData[dataIndex]?.netAmount || 0} /></strong> <FormattedMessage
                id='EGP' />
            </div>
          }
        }
      },
      {
        name: 'issuerName',
        key_name: 'issuerName',
        label: intl.formatMessage({ id: 'Fields.label.view.issuerName' }),
        options: {
          display: !!references ? 'false' : 'true',
          filter: false,
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return (!!listingData[dataIndex]?.issuerName || !!listingData[dataIndex]?.issuerId) ?
              <div className={classes.cellDataWrapper}>
                <strong>{listingData[dataIndex]?.issuerName || ''}</strong>
                {!!listingData[dataIndex]?.issuerId && <span>{listingData[dataIndex]?.issuerId}</span>}
              </div> :
              ((!!listingData[dataIndex]?.issuer?.name || !!listingData[dataIndex]?.issuer?.id) &&
                <div className={classes.cellDataWrapper}>
                  <strong>{listingData[dataIndex]?.issuer?.name || ''}</strong>
                  {!!listingData[dataIndex]?.issuer?.id && <span>{listingData[dataIndex]?.issuer?.id}</span>}
                </div>)
          }
        }
      },
      {
        name: 'issuerId',
        key_name: 'issuerId',
        label: intl.formatMessage({ id: 'Fields.label.view.issuerId' }),
        options: {
          display: false,
          viewColumns: false,
          filter: !!invoiceTypeFilterBackup?.direction && invoiceTypeFilterBackup?.direction === 'received',
          print: false,
          sort: false,
          download: false,
          filterType: 'custom',
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <TextField
                fullWidth
                label={intl.formatMessage({ id: 'Fields.label.view.issuerId' })}
                id='issuerId'
                name='issuerId'
                value={filterList[index][0] || ''}
                onKeyDown={handleEnterKeyDown}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              />
            )
          },
          customFilterListOptions: {
            render: (v) => {
              return <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.issuerId' />:
                <span>{v[0]}</span>
              </div>
            }
          },
          customBodyRenderLite: (dataIndex) => {
            return (!!listingData[dataIndex]?.issuerName || !!listingData[dataIndex]?.issuerId) &&
              <div className={classes.cellDataWrapper}>
                <strong>{listingData[dataIndex]?.issuerName || ''}</strong>
                {!!listingData[dataIndex]?.issuerId && <span>{listingData[dataIndex]?.issuerId}</span>}
              </div>
          }
        }
      },
      {
        name: 'receiverName',
        key_name: 'receiverId',
        label: intl.formatMessage({ id: 'Fields.label.view.receiverName' }),
        options: {
          filter: !!invoiceTypeFilterBackup?.direction && invoiceTypeFilterBackup?.direction === 'sent',
          print: false,
          sort: false,
          filterType: 'custom',
          download: false,
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <TextField
                fullWidth
                label={intl.formatMessage({ id: 'Fields.label.view.receiverName' })}
                id='receiverId'
                name='receiverId'
                value={filterList[index][0] || ''}
                onKeyDown={handleEnterKeyDown}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              />
            )

          },
          customBodyRenderLite: (dataIndex) => {
            return (!!listingData[dataIndex]?.receiverName || !!listingData[dataIndex]?.receiverId) ?
              <div className={classes.cellDataWrapper}>
                <strong>{listingData[dataIndex]?.receiverName || ''}</strong>
                {!!listingData[dataIndex]?.receiverId && <span>{listingData[dataIndex]?.receiverId}</span>}

                {/*<FormattedMessage id='Fields.label.view.receiverName' />:*/}
                {/*{!!listingData[dataIndex]?.receiverId && <span>{listingData[dataIndex]?.receiverName}</span>}*/}

                {/*{!!listingData[dataIndex]?.receiverId && <span>{listingData[dataIndex]?.receiverId}</span>}*/}
              </div> :
              ((!!listingData[dataIndex]?.receiver?.name || !!listingData[dataIndex]?.receiver?.id) &&
                <div className={classes.cellDataWrapper}>
                  <strong>{listingData[dataIndex]?.receiver?.name || ''}</strong>
                  {!!listingData[dataIndex]?.receiver?.id && <span>{listingData[dataIndex]?.receiver?.id}</span>}
                </div>)
          }
        }
      },
      {
        name: 'submissionUUID',
        key_name: 'submissionUUID',
        label: intl.formatMessage({ id: 'Fields.label.view.MSsubmissionUUID' }),
        options: {
          filter: false,
          display: 'false',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return <div className={classes.cellDataWrapper}>
              {!!listingData[dataIndex]?.submissionUUID &&
                <strong><NavLink
                  to={formatRoute(NamedRoutes.msSubmission, { id: listingData[dataIndex]?.submissionUUID })}>{listingData[dataIndex]?.submissionUUID}</NavLink></strong>}
              {/*{!!listingData[dataIndex]?.submissionMSUUID && <span>{listingData[dataIndex]?.submissionMSUUID}</span>}*/}
            </div>
          }
        }
      },
      {
        name: 'status',
        key_name: 'status',
        label: intl.formatMessage({ id: 'Fields.label.view.StatusAndMs' }),
        options: {
          filter: true,
          filterType: 'custom',
          print: false,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            let status = invoicesStatus?.filter(item => item.key.toString().toLowerCase() === listingData[dataIndex]?.status?.toString()?.toLowerCase())
            // let spStatus = invoicesSPStatus?.filter(item => item.key.toString().toLowerCase() === listingData[dataIndex]?.status?.toString()?.toLowerCase())
            let transformedState = (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.cancelRequestDate && !!listingData[dataIndex]?.cancelRequestDelayedDate)
              ? invoicesStatus?.filter(item => item.key.toString().toLowerCase() === 'cancelled')
              : (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.rejectRequestDate && !!listingData[dataIndex]?.rejectRequestDelayedDate)
                ? invoicesStatus?.filter(item => item.key.toString().toLowerCase() === 'rejected') : null
            let delayedDate = (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.cancelRequestDelayedDate)
              ? listingData[dataIndex]?.cancelRequestDelayedDate
              : (status[0]?.key === 'Valid' && !!listingData[dataIndex]?.rejectRequestDelayedDate)
                ? listingData[dataIndex]?.rejectRequestDelayedDate : null
            let isFreeze = !!listingData[dataIndex]?.freezeStatus?.frozen
            return <>
              {!!status && !!status.length && (!!isFreeze
                ? <HtmlTooltip placement={'top'} arrow interactive title={
                  <div className={classes.frozenWrapper}>
                    <div className={classes.frozenMessage}>
                      <FormattedMessage id='invoices.action.frozenMessage' values={{
                        strong: chunks => <strong>{chunks}</strong>,
                        date: <Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                          format={locale === 'ar' ? 'YYYY/MM/DD hh:mm A' : 'DD/MM/YYYY hh:mm A'}>{listingData[dataIndex]?.freezeStatus?.actionDate}</Moment>
                      }} />
                    </div>
                    <FormattedMessage id='invoices.action.frozenActions' />
                  </div>}>
                  <div>
                    <div className={classes.statusContainer}>
                      <div
                        className={classes.statusWrapper + ` ${listingData[dataIndex]?.status?.toString()?.toLowerCase()}${!!isFreeze ? ' freeze' : ''}`}>
                        {getStatusIcon(status[0]['key'], false, isFreeze)}
                        <strong>{status[0][`name_${locale}`]}</strong>
                      </div>
                      {!!transformedState && !!transformedState.length && <>
                        <ArrowForwardIcon />

                        <div
                          className={classes.statusWrapper + ` ${transformedState[0]['key']?.toString()?.toLowerCase()}`}>
                          {getStatusIcon(transformedState[0]['key'])}
                          <strong>{transformedState[0][`name_${locale}`]}</strong>
                        </div>
                      </>
                      }
                    </div>
                    {!!delayedDate &&
                      <div className={classes.statusDelayed}>
                        <label><FormattedMessage id='invoices.action.delayedDate' /></label>
                        <span>( <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                          format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{delayedDate}</Moment></strong>
                          <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                            format="hh:mm A">{delayedDate}</Moment></span> )
                        </span>
                      </div>
                    }
                  </div>
                </HtmlTooltip>
                : <>
                  <div className={classes.statusContainer}>
                    <div
                      className={classes.statusWrapper + ` ${listingData[dataIndex]?.status?.toString()?.toLowerCase()}`}>
                      {getStatusIcon(status[0]['key'])}
                      <strong>{status[0][`name_${locale}`]}</strong>
                    </div>
                    {!!transformedState && !!transformedState.length && <>
                      <ArrowForwardIcon />

                      <div
                        className={classes.statusWrapper + ` ${transformedState[0]['key']?.toString()?.toLowerCase()}`}>
                        {getStatusIcon(transformedState[0]['key'])}
                        <strong>{transformedState[0][`name_${locale}`]}</strong>
                      </div>
                    </>
                    }
                  </div>
                  {!!delayedDate &&
                    <div className={classes.statusDelayed}>
                      <label><FormattedMessage id='invoices.action.delayedDate' /></label>
                      <span>( <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                        format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{delayedDate}</Moment></strong>
                        <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                          format="hh:mm A">{delayedDate}</Moment></span> )
                      </span>
                    </div>
                  }
                </>
              )}
              {/* {!!status && <div
                className={classes.statusWrapper + ` spStatus`}>
                {status[0][`name_${locale}`]}
              </div>} */}
            </>
          },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <>
                <InputLabel id="MSStatus-label" className={'MuiInputLabel-shrink'}><FormattedMessage
                  id='Fields.label.view.Status' /></InputLabel>
                <Select
                  fullWidth
                  displayEmpty
                  labelId="MSStatus-label"
                  id="MSStatus"
                  name="MSStatus"
                  MenuProps={{ disableScrollLock: true }}
                  value={filterList[index][0] || ''}
                  label={intl.formatMessage({ id: 'Fields.label.view.Status' })}
                  onChange={(event) => {
                    // let value
                    if (!!event.target.value) {
                      filterList[index][0] = event.target.value
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                >
                  <MenuItem value={''}><FormattedMessage id='Table.List.Table.All' /></MenuItem>
                  {invoicesStatus?.length && invoicesStatus.map((item) => (
                    !!item.key &&
                    <MenuItem key={item.key} value={item.key}>
                      <div className={classes.statusWrapper + ` ${item['key']?.toString().toLowerCase()}`}>
                        {getStatusIcon(item['key'])}
                        <span>{item[`name_${locale}`]}</span>
                      </div>
                    </MenuItem>))}
                </Select>
              </>
            )
          },
          customFilterListOptions: {
            render: (v) => {
              let valueArr = v?.length && invoicesStatus?.length ? invoicesStatus.filter((item) => item.key.toString().toLowerCase() === v[0].toString().toLowerCase()) : []
              return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.Status' />:
                <div className={classes.statusWrapper + ` ${valueArr[0]['key']?.toString().toLowerCase()}`}>
                  {getStatusIcon(valueArr[0]['key'])}
                  <span>{valueArr[0][`name_${locale}`]}</span>
                </div>
              </div>
            }
          }
        }
      },
      {
        name: 'receiverType',
        key_name: 'receiverType',
        label: intl.formatMessage({ id: 'Fields.label.view.typeAndVersion' }),
        options: {
          display: false,
          viewColumns: false,
          filter: !!invoiceTypeFilterBackup?.direction && invoiceTypeFilterBackup?.direction === 'sent',
          filterType: 'custom',
          // customBodyRenderLite: (dataIndex) => {
          //   let type = msReceiverTypes?.filter(item => item.key.toString().toLowerCase() === listingData[dataIndex]?.typeName?.toString()?.toLowerCase())
          //   return !!type && !!type.length &&
          //     <div className={classes.cellDataWrapper}>
          //       <strong className={'noWrap'}>{type[0][`name_${locale}`]}</strong>
          //       <span className={'noWrap'}><FormattedMessage
          //         id='Fields.label.view.version' />: {listingData[dataIndex]?.typeVersionName}</span>
          //     </div>
          // },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <>
                <InputLabel id="DocumentTypeName-label" className={'MuiInputLabel-shrink'}><FormattedMessage
                  id='Fields.label.view.receiverType' /></InputLabel>
                <Select
                  fullWidth
                  displayEmpty
                  labelId="receiverType-label"
                  id="receiverType"
                  name="receiverType"
                  MenuProps={{ disableScrollLock: true }}
                  value={filterList[index][0] || ''}
                  label={intl.formatMessage({ id: 'Fields.label.view.receiverType' })}
                  onChange={(event) => {
                    if (!!event.target.value) {
                      filterList[index][0] = event.target.value
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                >
                  <MenuItem value={''}><FormattedMessage id='Table.List.Table.All' /></MenuItem>
                  {msReceiverTypes?.length && msReceiverTypes.map((item) => (
                    !!item.key &&
                    <MenuItem key={item.key} value={item.key}>{item[`name_${locale}`]}</MenuItem>))}
                </Select>
              </>
            )
          },
          customFilterListOptions: {
            render: (v) => {
              let valueArr = v?.length && msReceiverTypes?.length ? msReceiverTypes.filter((item) => item.key.toString().toLocaleLowerCase() === v[0].toString().toLowerCase()) : []
              return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.typeName' />:
                <span>{valueArr[0][`name_${locale}`]}</span>
              </div>
            }
          }
        }
      },
      {
        name: 'issuerType',
        key_name: 'issuerType',
        label: intl.formatMessage({ id: 'Fields.label.view.typeAndVersion' }),
        options: {
          display: false,
          viewColumns: false,
          filter: !!invoiceTypeFilterBackup?.direction && invoiceTypeFilterBackup?.direction === 'received',
          filterType: 'custom',
          // customBodyRenderLite: (dataIndex) => {
          //   let type = msReceiverTypes?.filter(item => item.key.toString().toLowerCase() === listingData[dataIndex]?.typeName?.toString()?.toLowerCase())
          //   return !!type && !!type.length &&
          //     <div className={classes.cellDataWrapper}>
          //       <strong className={'noWrap'}>{type[0][`name_${locale}`]}</strong>
          //       <span className={'noWrap'}><FormattedMessage
          //         id='Fields.label.view.version' />: {listingData[dataIndex]?.typeVersionName}</span>
          //     </div>
          // },
          filterOptions: {
            display: (filterList, onChange, index, column) => (
              <>
                <InputLabel id="DocumentTypeName-label" className={'MuiInputLabel-shrink'}><FormattedMessage
                  id='Fields.label.view.issuerType' /></InputLabel>
                <Select
                  fullWidth
                  displayEmpty
                  labelId="issuerType-label"
                  id="issuerType"
                  name="issuerType"
                  MenuProps={{ disableScrollLock: true }}
                  value={filterList[index][0] || ''}
                  label={intl.formatMessage({ id: 'Fields.label.view.issuerType' })}
                  onChange={(event) => {
                    if (!!event.target.value) {
                      filterList[index][0] = event.target.value
                    } else {
                      filterList[index] = []
                    }
                    onChange(filterList[index], index, column)
                  }}
                >
                  <MenuItem value={''}><FormattedMessage id='Table.List.Table.All' /></MenuItem>
                  {msIssuerTypes?.length && msIssuerTypes.map((item) => (
                    !!item.key &&
                    <MenuItem key={item.key} value={item.key}>{item[`name_${locale}`]}</MenuItem>))}
                </Select>
              </>
            )
          },
          customFilterListOptions: {
            render: (v) => {
              let valueArr = v?.length && msReceiverTypes?.length ? msReceiverTypes.filter((item) => item.key.toString().toLocaleLowerCase() === v[0].toString().toLowerCase()) : []
              return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.issuerType' />:
                <span>{valueArr[0][`name_${locale}`]}</span>
              </div>
            }
          }
        }
      },
      {
        name: 'dateFrom',
        key_name: 'issueDateFrom',
        label: intl.formatMessage({ id: 'Fields.label.view.dateFrom' }),
        options: {
          display: 'false',
          viewColumns: false,
          filter: true,
          filterType: 'custom',
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.dateFrom' />:
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
              </div>
            )
          },
          filterOptions: {
            names: [],
            display: (filterList, onChange, index, column) => (
              <>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
                  <DatePicker
                    autoOk
                    // ToolbarComponent={CustomToolbar}
                    fullWidth
                    format="dd-MM-yyyy"
                    margin="dense"
                    disableFuture
                    id="dateFrom"
                    name="dateFrom"
                    clearable
                    label={intl.formatMessage({ id: 'Fields.label.view.dateFrom' })}
                    placeholder={intl.formatMessage({ id: 'Fields.label.view.dateFrom' })}
                    InputProps={{
                      onKeyDown: handleEnterKeyDown,
                      endAdornment:
                        <InputAdornment position="end">
                          <EventIcon />
                        </InputAdornment>
                    }}
                    value={filterList[index][0] || null}
                    animateYearScrolling
                    onChange={(date) => {
                      if (!!date) {
                        filterList[index][0] = date
                      } else {
                        filterList[index] = []
                      }
                      onChange(filterList[index], index, column)
                    }}
                    cancelLabel={intl.formatMessage({ id: 'datePicker.Cancel' })}
                    okLabel={intl.formatMessage({ id: 'datePicker.confirm' })}
                    clearLabel={intl.formatMessage({ id: 'datePicker.clear' })}
                  />
                </MuiPickersUtilsProvider>

                {(!filterList[index][0] && !!filterList[index + 1][0]) &&
                  <FormHelperText margin="dense" variant='outlined' error={true}>
                    <FormattedMessage id='validationSchema.msInvoices.issueFrom' />
                  </FormHelperText>
                  // :
                  // ((!!filterList[index][0] || !!filterList[index + 1][0]) && (!!filterList[index][0] || !!filterList[index - 2][0])) &&
                  // <FormHelperText margin="dense" variant='outlined' error={true}>
                  //   <FormattedMessage id='validationSchema.msInvoices.filtersSchema' />
                  // </FormHelperText>
                }
              </>

            )
          }
        }
      },
      {
        name: 'dateTo',
        key_name: 'issueDateTo',
        label: intl.formatMessage({ id: 'Fields.label.view.dateTo' }),
        options: {
          display: 'false',
          viewColumns: false,
          filter: true,
          filterType: 'custom',
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.dateTo' />:
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
              </div>
            )
          },
          filterOptions: {
            names: [],
            display: (filterList, onChange, index, column) => (
              <>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
                  <DatePicker
                    autoOk
                    // ToolbarComponent={CustomToolbar}
                    fullWidth
                    disabled={!filterList[index - 1][0]}
                    minDate={filterList[index - 1][0] || null}
                    minDateMessage={<FormattedMessage id='validationSchema.msInvoices.min.issueTo' />}
                    disableFuture
                    format="dd-MM-yyyy"
                    margin="dense"
                    id="dateTo"
                    name="dateTo"
                    clearable
                    label={intl.formatMessage({ id: 'Fields.label.view.dateTo' })}
                    placeholder={intl.formatMessage({ id: 'Fields.label.view.dateTo' })}
                    InputProps={{
                      onKeyDown: handleEnterKeyDown,
                      endAdornment:
                        <InputAdornment position="end">
                          <EventIcon />
                        </InputAdornment>
                    }}
                    value={filterList[index][0] || null}
                    animateYearScrolling
                    onChange={(date) => {
                      if (!!date) {
                        filterList[index][0] = date
                      } else {
                        filterList[index] = []
                      }
                      onChange(filterList[index], index, column)
                    }}
                    cancelLabel={intl.formatMessage({ id: 'datePicker.Cancel' })}
                    okLabel={intl.formatMessage({ id: 'datePicker.confirm' })}
                    clearLabel={intl.formatMessage({ id: 'datePicker.clear' })}
                  />
                </MuiPickersUtilsProvider>
                {(!filterList[index][0] && !!filterList[index - 1][0]) &&
                  <FormHelperText margin="dense" variant='outlined' error={true}>
                    <FormattedMessage id='validationSchema.msInvoices.issueTo' />
                  </FormHelperText>
                  // :
                  // ((!!filterList[index][0] || !!filterList[index + 1][0]) && (!!filterList[index][0] || !!filterList[index - 2][0])) &&
                  // <FormHelperText margin="dense" variant='outlined' error={true}>
                  //   <FormattedMessage id='validationSchema.msInvoices.filtersSchema' />
                  // </FormHelperText>
                }
              </>

            )
          }
        }
      },
      {
        name: 'submissionDateFrom',
        key_name: 'submissionDateFrom',
        label: intl.formatMessage({ id: 'Fields.label.view.submissionDateFrom' }),
        options: {
          display: 'false',
          viewColumns: false,
          filter: true,
          filterType: 'custom',
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.submissionDateFrom' />:
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
              </div>
            )
          },
          filterOptions: {
            names: [],
            display: (filterList, onChange, index, column) =>
            (
              <>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
                  <DatePicker
                    autoOk
                    // ToolbarComponent={CustomToolbar}
                    fullWidth
                    format="dd-MM-yyyy"
                    margin="dense"
                    id="submissionDateFrom"
                    disableFuture
                    name="submissionDateFrom"
                    clearable
                    label={intl.formatMessage({ id: 'Fields.label.view.submissionDateFrom' })}
                    placeholder={intl.formatMessage({ id: 'Fields.label.view.submissionDateFrom' })}
                    InputProps={{
                      onKeyDown: handleEnterKeyDown,
                      endAdornment:
                        <InputAdornment position="end">
                          <EventIcon />
                        </InputAdornment>
                    }}
                    value={filterList[index][0] || null}
                    animateYearScrolling
                    onChange={(date) => {
                      if (!!date) {
                        filterList[index][0] = date
                      } else {
                        filterList[index] = []
                      }
                      onChange(filterList[index], index, column)
                    }}
                    cancelLabel={intl.formatMessage({ id: 'datePicker.Cancel' })}
                    okLabel={intl.formatMessage({ id: 'datePicker.confirm' })}
                    clearLabel={intl.formatMessage({ id: 'datePicker.clear' })}
                  />
                </MuiPickersUtilsProvider>
                {((!filterList[index][0] && !!filterList[index + 1][0]) && (!filterList[index] - 1[0] && !filterList[index - 2][0])) &&
                  <FormHelperText margin="dense" variant='outlined' error={true}>
                    <FormattedMessage id='validationSchema.msInvoices.submissionFrom' />
                  </FormHelperText>
                  // :
                  // ((!!filterList[index][0] || !!filterList[index + 1][0]) && (!!filterList[index][0] || !!filterList[index - 2][0])) &&
                  // <FormHelperText margin="dense" variant='outlined' error={true}>
                  //   <FormattedMessage id='validationSchema.msInvoices.filtersSchema' />
                  // </FormHelperText>

                }
              </>

            )
          }
        }
      },
      {
        name: 'submissionDateTo',
        key_name: 'submissionDateTo',
        label: intl.formatMessage({ id: 'Fields.label.view.submissionDateTo' }),
        options: {
          display: 'false',
          viewColumns: false,
          filter: true,
          filterType: 'custom',
          customFilterListOptions: {
            render: (v) => (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Fields.label.view.submissionDateTo' />:
                <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
              </div>
            )
          },
          filterOptions: {
            names: [],
            display: (filterList, onChange, index, column) => (
              <>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
                  <DatePicker
                    autoOk
                    // ToolbarComponent={CustomToolbar}
                    fullWidth
                    disabled={!filterList[index - 1][0]}
                    format="dd-MM-yyyy"
                    margin="dense"
                    id="submissionDateTo"
                    name="submissionDateTo"
                    minDate={filterList[index - 1][0] || null}
                    minDateMessage={<FormattedMessage id='validationSchema.msInvoices.min.submissionTo' />}

                    disableFuture
                    clearable
                    label={intl.formatMessage({ id: 'Fields.label.view.submissionDateTo' })}
                    placeholder={intl.formatMessage({ id: 'Fields.label.view.submissionDateTo' })}
                    InputProps={{
                      onKeyDown: handleEnterKeyDown,
                      endAdornment:
                        <InputAdornment position="end">
                          <EventIcon />
                        </InputAdornment>
                    }}
                    value={filterList[index][0] || null}
                    animateYearScrolling
                    onChange={(date) => {
                      if (!!date) {
                        filterList[index][0] = date
                      } else {
                        filterList[index] = []
                      }
                      onChange(filterList[index], index, column)
                    }}
                    cancelLabel={intl.formatMessage({ id: 'datePicker.Cancel' })}
                    okLabel={intl.formatMessage({ id: 'datePicker.confirm' })}
                    clearLabel={intl.formatMessage({ id: 'datePicker.clear' })}
                  />

                </MuiPickersUtilsProvider>
                {(!filterList[index][0] && !!filterList[index - 1][0]) &&
                  <FormHelperText margin="dense" variant='outlined' error={true}>
                    <FormattedMessage id='validationSchema.msInvoices.submissionTo' />
                  </FormHelperText>
                }
              </>
            )
          }
        }
      },
      {
        name: '',
        options: {
          filter: false,
          print: false,
          sort: false,
          viewColumns: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            return !!onlyDeleteOption ?
              <IconButton color="secondary" aria-label="Edit" onClick={(e) => {
                !!e?.preventDefault && e.preventDefault()
                !!e?.stopPropagation && e.stopPropagation()
                handleDeleteAction('delete', listingData[dataIndex], listingData[dataIndex]?.uuid)
              }}>
                <DeleteForeverIcon />
              </IconButton>
              :
              <>
              {console.log('listingData')}
              {console.log(listingData)}
              <AuthConsumer>
                {({ taxpayerSubscriptionsData }) => (
                  <InvoicesActionsMenu selectedRow={listingData[dataIndex]}
                  id={listingData[dataIndex]?.uuid}
                  msId={listingData[dataIndex]?.msUUID}
                  userPermissions={userPermissions}
                  hasQuota={!!taxpayerSubscriptionsData?.hasQuota}
                  isSubmitted={listingData[dataIndex]?.issuerId?.toString() === taxpayerData?.trn?.toString()}
                  locale={locale}
                  isMs={true}
                  />
                )}
              </AuthConsumer>
                </>
          }
        }
      }
    ]
  }

  return (
    <>
      {!onlyDeleteOption &&
        <InvoicesListingConsumer>
          {({ currentDialogAction, currentSelectedRow, dialogActionSubmit, cancelDialog, isDialogOpen, downloadLoading, downloadLoadingProgress }) => (
            <>
              <AddNewDialog
                children={<AddNewForm entityName={`invoicesActions-${currentDialogAction}`}
                  currentData={currentSelectedRow}
                  onSubmit={dialogActionSubmit}
                  currentAction={currentDialogAction}
                  cancelDialog={cancelDialog} />}
                dialogAction={currentDialogAction}
                DialogTitle={<FormattedMessage
                  id={`invoicesActions.dialogTitle.${currentDialogAction}`}
                  values={{ name: currentSelectedRow?.uuid || '' }} />}
                isDialogOpen={isDialogOpen}
                cancelDialog={cancelDialog}
              />
              {!!downloadLoading && <>
                <FormLoader loading={true} />
                <div className={classes.downloadProgressWrapper}>
                  <Box display="flex" alignItems="center" className={classes.progress}>
                    <Box width="100%" mr={1}>
                      <LinearProgress color={'primary'} variant="determinate" value={downloadLoadingProgress} />
                    </Box>
                    <Box minWidth={35}>
                      <Typography variant="body2"
                        color="primary">{`${downloadLoadingProgress}%`}</Typography>
                    </Box>
                  </Box>
                </div>
              </>}
            </>
          )}
        </InvoicesListingConsumer>
      }

      <div className={classes.fullWidth}>
        <InvoicesList
          title={
            !!noTypeFilter ?
              <Typography variant="h5">
                <FormattedMessage id={'SubmissionPageContent.TableTitle'} />
              </Typography>
              :
              <div className={classes.invoicesHeader}>
                <Typography variant="h5">
                  <InvoicesListingConsumer>
                    {({ invoiceTypeFilterBackup }) => (
                      tabEntityName === 'eInvoice' ?
                        <FormattedMessage
                          id={`InvoicesPageContent.TableTitle.${invoiceTypeFilterBackup?.invoiceDirection || invoiceTypeFilterBackup?.direction || 'all'}`} /> :
                        <FormattedMessage
                          id={`InvoicesPageContent.TableTitle.${invoiceTypeFilterBackup?.spStatus?.toString()?.replace(' ', '-') || 'all'}`} />
                    )}
                  </InvoicesListingConsumer>
                </Typography>
                <div className={classes.directionFormWrapper}>
                  {tabEntityName === 'eInvoice'
                    ? <InvoicesTypeForm onSubmit={handleInvoiceTypeFilterSubmit} />
                    : <InvoicesStatusForm onSubmit={handleInvoiceTypeFilterSubmit}
                      listingFiltersBackup={listingFiltersBackup} />}
                </div>
                {
                  (tabEntityName === 'eInvoice' && (!listingFiltersBackup || (Object.keys(listingFiltersBackup).length === 0 || (!!listingFiltersBackup && ((!!listingFiltersBackup.submissionDateFrom && !listingFiltersBackup.submissionDateTo) || (!!listingFiltersBackup && (!!listingFiltersBackup.submissionDateTo && !listingFiltersBackup.submissionDateFrom)))) || !['submissionDateFrom', 'submissionDateTo', 'issueDateTo', 'issueDateFrom'].some(key => Object.keys(listingFiltersBackup).includes(key))))) && (
                    <div className={classes.submissionDateContainer}>
                      <div className={classes.submissionDate}>
                        <h5><FormattedMessage id={'Invoices.List.Submission.From'} /></h5>
                        <span>{(!!listingFiltersBackup?.submissionDateFrom && !listingFiltersBackup?.submissionDateTo) ?
                          moment(listingFiltersBackup?.submissionDateFrom).locale(locale === 'ar' ? 'ar-sa' : 'en-us').format('DD-MM-YYYY')
                          : (!!listingFiltersBackup?.submissionDateTo && !listingFiltersBackup?.submissionDateFrom) ?
                            moment(listingFiltersBackup?.submissionDateTo).locale(locale === 'ar' ? 'ar-sa' : 'en-us').format('DD-MM-YYYY')
                            : moment().locale(locale === 'ar' ? 'ar-sa' : 'en-us').subtract(1, 'months').format('DD-MM-YYYY')}</span>
                      </div>
                      <div className={classes.submissionDateTo}>
                        <h5><FormattedMessage id={'Invoices.List.Submission.To'} /></h5>
                        <span>{(!!listingFiltersBackup?.submissionDateFrom && !listingFiltersBackup?.submissionDateTo) ?
                          moment(listingFiltersBackup?.submissionDateFrom).locale(locale === 'ar' ? 'ar-sa' : 'en-us').format('DD-MM-YYYY')
                          : (!!listingFiltersBackup?.submissionDateTo && !listingFiltersBackup?.submissionDateFrom) ?
                            moment(listingFiltersBackup?.submissionDateTo).locale(locale === 'ar' ? 'ar-sa' : 'en-us').format('DD-MM-YYYY')
                            : moment().locale(locale === 'ar' ? 'ar-sa' : 'en-us').format('DD-MM-YYYY')}</span></div>
                    </div>
                  )
                }

              </div>
          }
          submitFilterRef={submitFilterRef}
          setFilterData={setFilterData}
          columns={columns[tabEntityName]}
          handleListingFilterSubmit={handleListingFilterSubmit}
          noFilter={noFilter}
          listingData={listingData}
          listingPage={listingPage}
          listingCount={listingCount}
          listingRowsPerPage={listingRowsPerPage}
          handleChangeListingPage={handleChangeListingPage}
          handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
          noPagination={noPagination}
          hasContinuationToken={hasContinuationToken}
          continuationTokens={continuationTokens}
          currentIndex={currentIndex}
        />
      </div>

    </>
  )
}

export default TableWithFilter
